import { cacheDom } from "../utils/QuerySelectors.js"

const dom = {}
const qs = {
  paginator: 'data-paginator',
  results: 'data-pagination-result',
  nav: 'data-pagination-nav',
  resultPages: 'data-pages',
  resultArticles: 'data-articles',
  tilePaginator: 'data-tile-paginator',
}
const qsAll = {
  loadMoreBtns: 'data-load-more',
  pages: 'data-page-card',
  articles: 'data-article-card',
}

const iObserver = new IntersectionObserver(items => {
  if (items[0].isIntersecting) {
    const btn = items[0].target
    const paginator = btn.closest(`[${qs.paginator}]`)
    if(paginator) {
      const results = paginator.querySelector(`[${qs.results}]`)
      fetch(btn.href, { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html')
          const newResults = parsedHtml.querySelectorAll(`[${qs.results}] > *`)

          newResults.forEach((child) => results.appendChild(child))
          window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
          window.setupApiTiles(results)

          setTimeout(() => {
            window._swat.initializeActionButtons(`#product-grid`, '.plp-wishlist-btn')
          }, 300)

          if(dom.resultPages) {
            const pages = results.querySelectorAll(`[${qsAll.pages}]`)
            pages.forEach(page => dom.resultPages.appendChild(page.closest('li')))
          }
          if(dom.resultArticles) {
            const articles = results.querySelectorAll(`[${qsAll.pages}]`)
            articles.forEach(article => dom.resultArticles.appendChild(article.closest('li')))
          }

          btn.remove()
          if(parsedHtml.querySelector(`[${qsAll.loadMoreBtns}]`)) {
            const node = document.createElement("a")
            node.href = `${parsedHtml.querySelector(`[${qsAll.loadMoreBtns}]`).href}`
            node.className = "mx-auto inline-block invisible"
            node.setAttribute('data-load-more', '')
            node.textContent = 'More Results'
            paginator.querySelector(`[${qs.nav}]`).insertBefore(node, paginator.querySelector(`[${qs.itemsText}]`))
            iObserver.observe(paginator.querySelector(`[${qsAll.loadMoreBtns}]`))
          }
        })
    }
  }
})

const tileObserver = new IntersectionObserver(items => {
  if (items[0].isIntersecting) {
    let tile = items[0].target
    if(tile) {
      fetch(tile.getAttribute(qs.tilePaginator), { method: 'GET' })
        .then((response) => response.text())
        .then((html) => {
          const parsedHtml = new DOMParser().parseFromString(html, 'text/html')
          const newResults = parsedHtml.querySelectorAll(`[${qs.results}] > *`)

          newResults.forEach((child) => dom.results.appendChild(child))
          window.setupProductTiles(document.querySelectorAll('[product-tile]:empty'))
          window.setupApiTiles(dom.results)

          setTimeout(() => {
            window._swat.initializeActionButtons(`#product-grid`, '.plp-wishlist-btn')
          }, 300)

          tile.removeAttribute(qs.tilePaginator)
          tile = document.querySelector(`[${qs.tilePaginator}]`)
          if(tile) {
            console.log('tile', tile)
            tileObserver.observe(tile)
          }
        })
    }
  }
})

export const setupPaginations = () => {
  cacheDom(dom, qs, qsAll)
  dom.loadMoreBtns.forEach(btn => iObserver.observe(btn))
  if(dom.tilePaginator) tileObserver.observe(dom.tilePaginator)
}